import { use } from "i18next";

export const otherRoutes = [
  {
    path: "",
    state: "cp_cyber_protection_root",
    sidebarProps: {
      displayText: "CYBER_PROTECTION",
      icon: "Shield",
      isDisabled: false,
    },
    children: [
      {
        path: "/capabilities/Identity and Access Management",
        state: "cp_iam",
        sidebarProps: {
          displayText: "Identity and Access Management",
          isDisabled: false,
          showRawText: true,
          description:
            "Strategic planning and roadmap development for operations and advisiory",
        },
        children: [
          {
            path: "",
            state: "cp_planning_n_road",
            sidebarProps: {
              displayText: "Advisory",
              description:
                "Strategic planning and roadmap development for CyberArk IAM deployments.",
              isDisabled: false,
              showRawText: true,
            },
            children: [
              {
                path: "/console/chat",
                state: "cp_advisory_maturity",
                hasParameter: true,
                parameter: "Maturity",
                sidebarProps: {
                  description:
                    "Strategic planning and roadmap development for CyberArk IAM deployments.",
                  tags: ["Advisory", "IAM", "Maturity"],
                  displayText: "IAM Advisory Agent: Maturity Assessment",
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_advisory_cyberark",
                hasParameter: true,
                parameter: "CyberarkIAM",
                sidebarProps: {
                  displayText: "IAM Advisory Agent: CyberArk",
                  description:
                    "Strategic planning and roadmap development for CyberArk IAM deployments.",
                  tags: ["Advisory", "IAM", "CyberArk"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_advisory_okta",
                hasParameter: true,
                parameter: "OktaIAM",
                sidebarProps: {
                  displayText: "IAM Advisory Agent: Okta",
                  description:
                    "Strategic planning and roadmap development for Okta IAM deployments.",
                  tags: ["Advisory", "IAM", "Okta"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_advisory_sailpoint",
                hasParameter: true,
                parameter: "SailpointIAM",
                sidebarProps: {
                  displayText: "IAM Advisory Agent: SailPoint",
                  description:
                    "Strategic planning and roadmap development for SailPoint IAM deployments.",
                  tags: ["Advisory", "IAM", "SailPoint"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_advisory_saviynt",
                hasParameter: true,
                parameter: "SavyintIAM",
                sidebarProps: {
                  displayText: "IAM Advisory Agent: Saviynt",
                  description:
                    "Strategic planning and roadmap development for Savyint IAM deployments.",
                  tags: ["Advisory", "IAM", "Savyint"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_advisory_ping",
                hasParameter: true,
                parameter: "pingadvisoryassistant",
                sidebarProps: {
                  displayText: "IAM Advisory Agent: Ping",
                  description:
                    "Strategic planning and roadmap development for Ping IAM deployments.",
                  tags: ["Advisory", "IAM", "Ping"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
            ],
          },
          // {
          //   path: "",
          //   state: "cp_iam_transformation",
          //   sidebarProps: {
          //     displayText: "Transformation IAM",
          //     isDisabled: false,
          //     description:
          //       "Strategic planning and roadmap development for Okta IAM deployments.",
          //     showRawText: true,
          //   },
          //   children: [
          //     {
          //       path: "/console/chat",
          //       state: "cp_iam_design",
          //       hasParameter: true,
          //       parameter: "IAMTransformation",
          //       sidebarProps: {
          //         displayText: "Design IAM - Demo",
          //         description:
          //           "Design services for IAM transformation initiatives.",
          //         tags: ["Transformation", "IAM", "Design"],
          //         isDisabled: false,
          //         showRawText: true,
          //       },
          //     },
          //   ],
          // },
          {
            path: "",
            state: "cp_iam_operations",
            sidebarProps: {
              displayText: "Operations",
              description:
                "Strategic planning and roadmap development for Okta IAM deployments.",
              isDisabled: false,
              showRawText: true,
            },
            children: [
              {
                path: "/console/chat",
                state: "cp_iam_op_jobaid",
                hasParameter: true,
                parameter: "iam_jobaid",
                sidebarProps: {
                  displayText: "IAM Operations Agent: Accenture Security Tenant",
                  description:
                    "Smart Documentation Lookup across CyberArk, Sailpoint, and Okta.",
                  tags: ["Operations", "CyberArk", "Sailpoint", "Okta", "Saviynt", "Microsoft", "Ping"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_cyberark",
                hasParameter: true,
                parameter: "CyberArkOpsAsst",
                sidebarProps: {
                  displayText: "IAM Operations Agent: CyberArk demo",
                  description:
                    "Managing and optimizing CyberArk operations with AI-driven automation.",
                  tags: ["Operations", "CyberArk"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_cyberark_corteva",
                hasParameter: true,
                parameter: "CyberArkIAMOperations",
                sidebarProps: {
                  displayText: "Corteva - CyberArk Operations",
                  description:
                    "Managing and optimizing CyberArk operations with AI-driven automation.",
                  tags: ["Operations", "CyberArk", "Corteva"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_sailpoint_corteva",
                hasParameter: true,
                parameter: "SailPointIAMOperations",
                sidebarProps: {
                  displayText: "Corteva - SailPoint Operations",
                  description:
                    "Managing and optimizing SailPoint operations with AI-driven automation.",
                  tags: ["Operations", "SailPoint", "Corteva"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_ticketquality_corteva",
                hasParameter: true,
                parameter: "IAMTicketQualityEvaluator",
                sidebarProps: {
                  displayText: "Corteva - IAM Ticket Quality Evaluator",
                  description:
                    "Managing and optimizing CyberArk and SailPoint operations with AI-driven automation.",
                  tags: ["Operations", "SailPoint", "CyberArk", "Corteva"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_okta",
                hasParameter: true,
                parameter: "OktaOpsAsst",
                sidebarProps: {
                  displayText: "IAM Operations Agent: Okta demo",
                  description:
                    "Managing and optimizing Okta operations with AI-driven automation.",
                  tags: ["Operations", "Okta"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_op_sailpoint",
                hasParameter: true,
                parameter: "SailPointOpsAsst",
                sidebarProps: {
                  displayText: "IAM Operations Agent: SailPoint demo",
                  description:
                    "Managing and optimizing SailPoint operations with AI-driven automation.",
                  tags: ["Operations", "SailPoint"],
                  isDisabled: false,
                  showRawText: true,
                },
              },
            ],
          },
          {
            path: "",
            state: "cp_access_governance",
            sidebarProps: {
              displayText: "Access Governance",
              isDisabled: false,
              description:
                "Strategic planning and roadmap development for Okta IAM deployments.",
              showRawText: true,
            },
            children: [
              {
                path: "https://teams.microsoft.com/v2/",
                state: "cp_iam_accgov_omada",
                hasParameter: true,
                sidebarProps: {
                  displayText: "Access Governance Omada - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description: "Access governance solutions using Omada.",
                  tags: ["Governance", "Omada"],
                },
              },
              {
                path: "/console/chat",
                state: "cp_iam_accgov_sailpoint",
                hasParameter: true,
                parameter: "SailpointIAM",
                sidebarProps: {
                  displayText: "Access Governance SailPoint - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description: "Access governance solutions using SailPoint.",
                  tags: ["Governance", "SailPoint"],
                },
              },
            ],
          },
        ],
      },
      {
        path: "/capabilities/Cloud & Application Security",
        state: "cp_cloud_app_sec",
        sidebarProps: {
          displayText: "Cloud & Application Security",
          isDisabled: false,
          showRawText: true,
          description:
            "Expanding security visibility across cloud and applications with AI-powered automation.",
        },
        children: [
          {
            path: "",
            state: "cp_ac2_wrapper",
            sidebarProps: {
              displayText: "Continuous Compliance",
              isDisabled: false,
              showRawText: true,
            },
            children: [
              {
                path: "/console/cp/ac2/home",
                state: "cp_ac2_home",
                sidebarProps: {
                  displayText: "Compliance Agents Dashboard Home - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "AI-driven compliance mapping and automated control validation - Home page.",
                  tags: ["Compliance", "Cloud", "Automation"],
                },
              },
              {
                path: "/console/cp/ac2/cases",
                state: "cp_ac2_cases",
                sidebarProps: {
                  displayText: "Compliance Agents Dashboard Cases - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "AI-driven compliance mapping and automated control validation - Cases management.",
                  tags: ["Compliance", "Cloud", "Cases"],
                },
              },
              {
                path: "/console/cp/ac2/frameworks",
                state: "cp_ac2_frameworks",
                sidebarProps: {
                  displayText: "Compliance Agents Dashboard Frameworks - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "AI-driven compliance mapping and automated control validation - Frameworks view.",
                  tags: ["Compliance", "Cloud", "Frameworks"],
                },
              },
            ],
          },
          {
            path: "https://ts.accenture.com/sites/Information_Security4/StandardsControls/StandardsLibrary/Administrative%20Access%20Tools%20-%20Security%20Guidelines.aspx",
            state: "cp_is_arch_standard_search",
            hasParameter: true,
            sidebarProps: {
              displayText: "Information Security Standards Search",
              isDisabled: false,
              showRawText: true,
              description:
                "Search Accenture's architecture and standards",
              tags: ["Standards", "Architecture", "Search"],
            },
          },
          {
            path: "",
            state: "cp_secure_cloud_express_apps",
            sidebarProps: {
              displayText: "SCE Applications",
              isDisabled: false,
              showRawText: true,
            },
            children: [
              {
                path: "/console/chat",
                state: "cp_secure_cloud_prisma",
                parameter: "SCEPrismaProcessor",
                hasParameter: true,
                sidebarProps: {
                  displayText: "Secure Cloud Express for Prisma",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Cloud security visibility and automated remediation using Prisma.",
                  tags: ["Cloud", "Security", "Prisma"],
                },
              },
              {
                path: "/console/chat",
                state: "cp_secure_cloud_express_main",
                parameter: "WIZSCEProcessor",
                hasParameter: true,
                sidebarProps: {
                  displayText: "Secure Cloud Express",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Cloud security visibility and automated remediation.",
                  tags: ["Cloud", "Security"],
                },
              },
            ],
          },
        ],
      },
      {
        path: "/capabilities/Enterprise Platform Security",
        state: "cp_enterprise_platform_security",
        sidebarProps: {
          displayText: "Enterprise Platform Security",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "/console/chat",
            state: "cp_sap_security_role_design",
            hasParameter: false,
            parameter: "SAPMatrix",
            sidebarProps: {
              displayText: "SAP Security Role Design Assistant",
              description:
                "AI assistant for designing secure SAP role configurations.",
              tags: ["SAP", "Security", "Role Design"],
              isDisabled: false,
              showRawText: true,
            },
          },
        ],
      },
      {
        path: "/capabilities/Secure AI",
        state: "cp_secure_ai_container",
        sidebarProps: {
          displayText: "Secure AI",
          isDisabled: false,
          showRawText: true,
          description:
            "Design and implementation of Zero Trust security architecture.",
          tags: ["Zero Trust", "Architecture", "Design", "SASE"],
        },
        children: [
          {
            path: "https://app.securiti.ai/#/",
            state: "cp_secure_ai",
            hasParameter: true,
            sidebarProps: {
              displayText: "Secure AI",
              isDisabled: false,
              showRawText: true,
              description:
                "Comprehensive security assessment for AI and ML models.",
              tags: ["AI Security", "Assessment", "Model Protection"],
            },
          },
        ]
      },
      // {
      //   path: "/capabilities/Data Security",
      //   state: "cp_data_security",
      //   sidebarProps: {
      //     displayText: "Data Security",
      //     isDisabled: false,
      //     showRawText: true,
      //     description: "Automated data classification and governance solution.",
      //     tags: ["Data Classification", "Governance", "Compliance"],
      //   },
      // },
      {
        path: "/capabilities/Zero Trust, SASE",
        state: "cp_zero_trust_sase",
        sidebarProps: {
          displayText: "Zero Trust, SASE",
          isDisabled: false,
          showRawText: true,
          description:
            "Design and implementation of Zero Trust security architecture.",
          tags: ["Zero Trust", "Architecture", "Design", "SASE"],
        },
        children: [
          {
            path: "/console/chat",
            state: "cp_ztse",
            hasParameter: true,
            parameter: "zerotrustsase",
            sidebarProps: {
              description:
                "Zero Trust Secure Access Service Edge Assistant.",
              tags: ["Advisory", "IAM", "ZeroTrust"],
              displayText: "Zero Trust SASE",
              isDisabled: false,
              showRawText: true,
            },
          },
    ]
      },
    ],
  },
  {
    path: "",
    state: "cyber_resilience_root",
    sidebarProps: {
      displayText: "CYBER_RESILIENCE",
      icon: "RefreshCcw",
      isDisabled: false,
    },
    children: [
      {
        path: "/capabilities/Cyber Defense",
        state: "cr_cyber_defense",
        sidebarProps: {
          displayText: "Cyber Defense",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "",
            state: "cr_soc_ai_assistant",
            sidebarProps: {
              displayText: "SOC AI Agents",
              isDisabled: false,
              showRawText: true,
            },
            children: [
              {
                path: "",
                state: "cr_flywheel",
                sidebarProps: {
                  displayText: "FLYWHEEL",
                  isDisabled: false,
                },
                children: [
                  {
                    path: "/console/cr/flywheel/home",
                    state: "cr_fly_cases",
                    sidebarProps: {
                      displayText: "SOC AI Agent Suite Home - Demo",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "AI assistant for SOC analysts using the SOC AI platform - Home page.",
                      tags: ["SOC", "Threat Detection", "SOC AI"],
                    },
                  },
                  {
                    path: "/console/cr/flywheel/incidents",
                    state: "cr_fly_incidents",
                    sidebarProps: {
                      displayText: "SOC AI Agent Suite Incidents - Demo",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "AI assistant for SOC analysts using the SOC AI platform - Incident management.",
                      tags: ["SOC", "Incidents", "SOC AI"],
                    },
                  },
                  {
                    path: "https://es.fa-preview-accenture.splunkcloud.com/en-US/account/login?return_to=%2Fen-US%2Fapp%2Fmissioncontrol%2Fmc_incident_review%3Fearliest%3D-24h%2540h%26latest%3Dnow%26num_per_page%3D20%26order%3Ddesc%26page%3D1%26sort%3Dlimit%253D0%2520-create_time%2520id%26sort_field%3D-create_time#/e32aafc7-4fb7-45f9-91ed-a9b4cfd68f9e/overview",
                    state: "cr_fly_incidents_splunk",
                    hasParameter: true,
                    sidebarProps: {
                      displayText: "SOC AI Agent Suite for Splunk - Demo",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "AI assistant for SOC analysts using the SOC AI platform - Splunk integration.",
                      tags: ["SOC", "Splunk", "SOC AI"],
                    },
                  },
                ],
              },
              {
                path: "https://accenture-usp11-f1.siemplify-soar.com/#/cases/146940",
                state: "cr_mxdr-google",
                hasParameter: true,
                sidebarProps: {
                  displayText: "SOC AI Agent Suite for Google SecOps - Demo",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Managed Extended Detection and Response on Google platform.",
                  tags: ["MXDR", "Google", "Detection"],
                },
              },
              {
                path: "",
                state: "cr_malware",
                sidebarProps: {
                  displayText: "Malware",
                  isDisabled: false,
                  showRawText: true,
                },
                children: [
                  {
                    path: "/console/chat",
                    state: "cr_suspicious_code_analysis",
                    hasParameter: true,
                    parameter: "GeminiProMalwareChat",
                    sidebarProps: {
                      displayText: "Suspicious Code Analysis",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "AI-powered analysis of potentially malicious code.",
                      tags: ["Malware", "Code Analysis", "Security"],
                    },
                  },
                  {
                    path: "/console/chat",
                    state: "cr_suspicious_file_analysis",
                    hasParameter: true,
                    parameter: "GeminiProMalwareUpload",
                    sidebarProps: {
                      displayText: "Suspicious File Analysis",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "AI-powered analysis of suspicious files for malware detection.",
                      tags: ["Malware", "File Analysis", "Security"],
                    },
                  },
                ],
              },
              {
                path: "/console/chat",
                state: "cr_report_generator",
                hasParameter: true,
                parameter: "GeminiProReportGenerator",
                sidebarProps: {
                  displayText: "Report Generation",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Incident Report Genration via AI.",
                  tags: ["XSOAR", "Report Generation", "Security"],
                },
              },
              {
                path: "/console/chat",
                state: "cr_report_generator_corteva",
                hasParameter: true,
                parameter: "ReportGenerator",
                sidebarProps: {
                  displayText: "Corteva - Report Generation",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Incident Report Genration via AI.",
                  tags: ["XSOAR", "Report Generation", "Security", "Corteva"],
                }
              },
              {
                path: "/console/chat",
                state: "cr_soc_ticket_quality_corteva",
                hasParameter: true,
                parameter: "CortevaSOCTicketQualityEvaluator",
                sidebarProps: {
                  displayText: "Corteva - SOC Ticket Quality",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Ticket Quality Evaluator via AI.",
                  tags: ["XSOAR", "Security", "Corteva"],
                }
              },
              {
                path: "/console/chat",
                state: "cr_language_translation",
                hasParameter: true,
                parameter: "Translate",
                sidebarProps: {
                  displayText: "Language Translation",
                  isDisabled: false,
                  showRawText: true,
                  description:
                    "Real-time translation of threat intelligence from multiple languages.",
                  tags: ["Translation", "Intelligence", "Global"],
                },
              },
              {
                path: "",
                state: "cr_soc_kb_search",
                sidebarProps: {
                  displayText: "SOC KB Search",
                  isDisabled: false,
                  showRawText: true,
                },
                children: [
                  {
                    path: "https://gnxt.secaiasst.com/Demo",
                    state: "cr_soc_kb_search_leadership",
                    hasParameter: true,
                    sidebarProps: {
                      displayText: "SOC Knowledge base Search for Leadership - Demo",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "Knowledge base search tool for SOC leadership.",
                      tags: ["SOC", "Knowledge Base", "Leadership"],
                    },
                  },
                  {
                    path: "/console/chat",
                    state: "cr_soc_kb_search_analyst",
                    hasParameter: true,
                    parameter: "SocKnowledgebaseSearch",
                    sidebarProps: {
                      useNiceName: false,
                      customPrefix: "SOC KB Search for ",
                      displayText: "SOC Knowledge base Search for Analyst - Demo",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "Knowledge base search tool for SOC analysts (Without RAG).",
                      tags: ["SOC", "Knowledge Base", "Analyst"],
                    },
                  },
                  {
                    path: "/console/chat",
                    state: "cr_soc_kb_search_corteva",
                    hasParameter: true,
                    parameter: "CortevaSocKnowledgebaseSearch",
                    sidebarProps: {
                      useNiceName: false,
                      customPrefix: "SOC KB Search for ",
                      displayText: "Corteva - SOC Knowledgebase Search",
                      isDisabled: false,
                      showRawText: true,
                      description:
                        "SOC Knowledge base search tool for Corteva.",
                      tags: ["SOC", "Knowledge Base", "Analyst", "Corteva"],
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/capabilities/Cyber Readiness & Response",
        state: "cr_cyber_rediness_and_response",
        sidebarProps: {
          displayText: "Cyber Readiness & Response",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "https://cyber-secai-prod.secaiasst.com/console/login",
            state: "cr_cifr_rag",
            hasParameter: true,
            sidebarProps: {
              displayText: "CIFR RAG",
              isDisabled: false,
              showRawText: true,
              description: "Cyber Forensics Incident Response with Retrieval Augmented Generation.",
              tags: ["CIFR", "Response", "RAG"],
            },
          },
          {
            path: "/console/cr/pentest",
            state: "cr_pentest_resilience",
            sidebarProps: {
              displayText: "Pentest Resilience Automation",
              isDisabled: false,
              showRawText: true,
              description:
                "An automated assistant that streamlines penetration testing workflows. Analyzes targets, conducts automated scans, interprets results, and generates comprehensive security assessment reports for red team analysts.",
              tags: ["Pentest", "Automation", "Resilience"],
            },
          },
          {
            path: "/console/cr/ctem",
            state: "cr_ctem_resilience",
            sidebarProps: {
              displayText: "CTEM Resilience Automation",
              isDisabled: false,
              showRawText: true,
              description:
                "An automated assistant that streamlines CTEM workflows. Analyzes threat exposures, conducts automated assessments, interprets results, and generates comprehensive exposure management reports for red team analysts.",
              tags: ["CTEM", "Automation", "Resilience"],
            },
          },
          {
            path: "/console/soon",
            state: "cr_intelliegence",
            sidebarProps: {
              displayText: "CR&R Assistant",
              isDisabled: false,
              showRawText: true,
              description: "Cyber Readiness and Response assistant tool.",
              tags: ["Readiness", "Response", "Assistant"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_cifr_tools",
            hasParameter: true,
            parameter: "CIFRTools",
            sidebarProps: {
              displayText: "CIFRTools",
              isDisabled: false,
              showRawText: true,
              description: "CIFR tools",
              tags: ["CIFR", "TOOLS", "Response"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Cyber Intelligence",
        state: "cr_cyber_intelligence",
        sidebarProps: {
          displayText: "Cyber Intelligence",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "/console/chat",
            state: "cr_telecom_agent",
            hasParameter: true,
            parameter: "TelecomDemo",
            sidebarProps: {
              displayText: "Telecom Intelligence - Demo",
              isDisabled: false,
              showRawText: true,
              description:
                "Specialized intelligence for telecommunications security.",
              tags: ["Telco", "Intelligence", "Specialized"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_cyber_intel_search",
            hasParameter: true,
            parameter: "MandientRAG",
            sidebarProps: {
              displayText: "Cyber Intel Search",
              isDisabled: false,
              showRawText: true,
              description:
                "Advanced search and analysis of threat intelligence data.",
              tags: ["Intelligence", "Search", "Analysis"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_ti_augmentation",
            hasParameter: true,
            parameter: "TI_Augment",
            sidebarProps: {
              displayText: "Threat Intel Assistant",
              isDisabled: false,
              showRawText: true,
              description:
                "Enhanced threat intelligence with AI-driven context and insights.",
              tags: ["Intelligence", "Augmentation", "Context"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_ctem_ai_assistant",
            hasParameter: true,
            parameter: "ReportGeneratorASM",
            sidebarProps: {
              displayText: "CTEM AI",
              isDisabled: false,
              showRawText: true,
              description: "AI-assisted Cyber Threat Exposure Management.",
              tags: ["CTEM", "Threat", "Exposure"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_vulnerability_recommendation",
            hasParameter: true,
            parameter: "ReportGeneratorVulnRec",
            sidebarProps: {
              displayText: "Vulnerability Analysis and Remediation Recommendation",
              isDisabled: false,
              showRawText: true,
              description: "AI-assisted Vulnerability Recommendation and Management.",
              tags: ["Vulnerability", "Recommendation", "Security"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Cyber Transformation",
        state: "cr_cyber_transformation",
        sidebarProps: {
          displayText: "Cyber Transformation",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "https://accenture-dev-genai.siemplify-soar.com",
            state: "cr_detection_rules_translation",
            hasParameter: true,
            sidebarProps: {
              displayText: "Detection Rules Translation ",
              isDisabled: false,
              showRawText: true,
              description:
                "Translation of detection rules across different security platforms.",
              tags: ["Detection", "Rules", "Translation"],
            },
          },
          {
            path: "/console/chat",
            state: "autostp",
            hasParameter: true,
            parameter: "AutoSTP",
            sidebarProps: {
              displayText: "AutoSTP",
              isDisabled: false,
              showRawText: true,
              description:
                "AI assistant for cybersecurity solution based on Summiting the Pyramid.",
              tags: [],
            },
          },
        ],
      },
    ],
  },
  {
    path: "",
    state: "cyber_strategy_root",
    sidebarProps: {
      displayText: "Cyber Strategy",
      icon: "Brain",
      isDisabled: false,
      showRawText: true,
    },
    children: [
      {
        path: "/capabilities/Cyber Strategy & Organization",
        state: "cyber_strategy_and_organization",
        sidebarProps: {
          displayText: "Cyber Strategy & Organization",
          isDisabled: false,
          showRawText: true,
          description:
            "Strategic planning and organizational design for cybersecurity.",
          tags: ["Strategy", "Organization", "Planning"],
        },
        children: [
          {
            path: "/console/soon",
            state: "cyber_strategy_and_organization",
            sidebarProps: {
              displayText: "Cyber Strategy & Organization",
              isDisabled: false,
              showRawText: true,
              description:
                "Strategic planning and organizational design for cybersecurity.",
              tags: ["Strategy", "Organization", "Planning"],
            },
          },
          {
            path: "/console/chat",
            state: "cr_cyber_threat_analysis",
            hasParameter: true,
            parameter: "SecurityAnalysisGPT",
            sidebarProps: {
              useNiceName: false,
              displayText: "SecurityAnalysis",
              isDisabled: false,
              showRawText: true,
              description:
                "Security analysis",
              tags: ["Security", "Audit", "Analysis"],
            },
          },
          {
            path: "/console/secai/ctep",
            state: "cr_cyber_threat_analysis_form",
            hasParameter: true,
            parameter: "SecurityAnalysisGPT",
            sidebarProps: {
              useNiceName: false,
              displayText: "SecurityAnalysis Form version",
              isDisabled: false,
              showRawText: true,
              description:
                "Security analysis",
              tags: ["Security", "Audit", "Analysis"],
            },
          },
          {
            path: "/console/chat",
            state: "security_architecture_review",
            hasParameter: true,
            parameter: "SARAgent",
            sidebarProps: {
              displayText: "Security Architecture Review",
              isDisabled: false,
              showRawText: true,
              description:
                "Asset to help automation of security architecture review as part of AppSec scan process.",
              tags: ["SAR", "Architecture"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Cyber Risk & Regulatory",
        state: "cyber_risk_and_regulatory_container",
        sidebarProps: {
          displayText: "Compliance",
          isDisabled: false,
          showRawText: true,
          description: "Management of cyber risk and regulatory compliance.",
          tags: ["Risk", "Regulatory", "Compliance"],
        },
        children: [
          {
            path: "/console/soon",
            state: "cyber_risk_and_regulatory",
            sidebarProps: {
              displayText: "Cyber Risk & Regulatory",
              isDisabled: false,
              showRawText: true,
              description:
                "Management of cyber risk and regulatory compliance.",
              tags: ["Risk", "Regulatory", "Compliance"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Cyber Risk & Compliance",
        state: "cyber_risk_and_compliance",
        sidebarProps: {
          displayText: "Cyber Risk & Compliance",
          isDisabled: false,
          showRawText: true,
          description:
            "Comprehensive cyber risk and compliance management solutions.",
          tags: ["Risk", "Compliance", "Management"],
        },
        children: [
          {
            path: "/console/chat",
            state: "chat_demo_regaiasst",
            hasParameter: true,
            parameter: "RegCompliance",
            sidebarProps: {
              useNiceName: false,
              displayText: "Regulatory & Compliance AI Asst",
              isDisabled: false,
              showRawText: true,
              description: "Demo - Regulatory Compliance AI Assistant",
              tags: ["AI", "Chat", "Security"],
            },
          },
          {
            path: "/console/chat",
            state: "nist_sf_ppt_generator_demo",
            hasParameter: true,
            parameter: "nist-csf-ppt-generator",
            sidebarProps: {
              displayText: "NIST CSF PPT Generator",
              isDisabled: false,
              showRawText: true,
              description: "GEN AI based NIST CSF PPTX Generator",
              tags: ["AI", "NIST CSF", "PPTX"],
            },
          },

          {
            path: "/console/soon",
            state: "cyber_risk_and_compliance",
            sidebarProps: {
              displayText: "Cyber Risk & Compliance",
              isDisabled: false,
              showRawText: true,
              description:
                "Comprehensive cyber risk and compliance management solutions.",
              tags: ["Risk", "Compliance", "Management"],
            },
          },
        ],
      },
      {
        path: "/capabilities/C-Suite & Board Cyber Advisory",
        state: "c_suite_board_cyber_advisory",
        sidebarProps: {
          displayText: "C-Suite & Board Cyber Advisory",
          isDisabled: false,
          showRawText: true,
          description:
            "Executive-level advisory services for cyber strategy and risk.",
          tags: ["Executive", "Advisory", "Board"],
        },
        children: [
          {
            path: "/console/soon",
            state: "c_suite_board_cyber_advisory",
            sidebarProps: {
              displayText: "C-Suite & Board Cyber Advisory",
              isDisabled: false,
              showRawText: true,
              description:
                "Executive-level advisory services for cyber strategy and risk.",
              tags: ["Executive", "Advisory", "Board"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "",
    state: "cyber_physical_root",
    sidebarProps: {
      displayText: "CYBER_PHYSICAL",
      icon: "Factory",
      isDisabled: false,
    },
    children: [
      {
        path: "/capabilities/Operational Technology Security",
        state: "operational_technology_security",
        sidebarProps: {
          displayText: "Operational Technology",
          isDisabled: false,
          showRawText: true,
        },
        children: [
          {
            path: "/console/chat",
            state: "aero_space_and_defense_cmmc",
            hasParameter: true,
            parameter: "CMMCAA",
            sidebarProps: {
              displayText: "CMMC (Aero Space & Defense)",
              isDisabled: false,
              showRawText: true,
              description:
                "CMMC compliance assessment tool",
              tags: ["Aerospace", "Defense", "CMMC"],
            },
          },
          {
            path: "/console/chat",
            state: "data_center_compliance",
            hasParameter: true,
            parameter: "OTAssessment",
            sidebarProps: {
              displayText: "Data Center Compliance",
              isDisabled: false,
              showRawText: true,
              description:
                "Compliance management for data center operations and security.",
              tags: ["Data Center", "Compliance", "Infrastructure"],
            },
          },
          {
            path: "/console/chat",
            state: "ot_ai_compliance",
            hasParameter: true,
            parameter: "DelfosSearch",
            sidebarProps: {
              displayText: "OT Standards Search",
              isDisabled: false,
              showRawText: true,
              description:
                "AI-powered compliance management for operational technology environments.",
              tags: ["OT", "Compliance", "AI"],
            },
          },
          {
            path: "/console/chat",
            state: "NIST_800-53_Assistant",
            hasParameter: true,
            parameter: "NIST_800-53_Assistant",
            sidebarProps: {
              displayText: "NIST 800-53 Assistant",
              isDisabled: false,
              showRawText: true,
              description:
                "NIST 800-53 compliance assessment tool",
              tags: ["NIST 800-53", "Compliance", "NIST"],
            },
          },
          {
            path: "/console/chat",
            state: "caasm_ot_asset_intelligence",
            hasParameter: true,
            parameter: "CAASM",
            sidebarProps: {
              displayText: "CAASM OT Asset Intelligence",
              isDisabled: false,
              showRawText: true,
              description:
                "CAASM OT Asset Intelligence",
              tags: ["Operational Technology", "Asset Intelligence", "CAASM"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Product Security",
        state: "ot_product_security_container",
        sidebarProps: {
          displayText: "Product Security",
          isDisabled: false,
          showRawText: true,
          description:
            "Security solutions for product development and deployment."
        },
        children: [
          {
            path: "/console/soon",
            state: "ot_product_security",
            sidebarProps: {
              displayText: "Product Security",
              isDisabled: false,
              showRawText: true,
              description:
                "Security solutions for product development and deployment.",
              tags: ["Product", "Security", "Development"],
            },
          },
        ]
      },
    ],
  },
  {
    path: "",
    state: "cyber_next_root",
    sidebarProps: {
      displayText: "CyberNext",
      icon: "Rocket",
      isDisabled: false,
      showRawText: true,
    },
    children: [
      {
        path: "/capabilities/Quantum Security",
        state: "cn_cyber_quantum_security_container",
        sidebarProps: {
          displayText: "Quantum Security",
          isDisabled: false,
          showRawText: true,
          description:
            "Preparing for quantum computing threats and opportunities.",
        },
        children: [
          {
            path: "/console/soon",
            state: "cn_cyber_quantum_security",
            sidebarProps: {
              displayText: "Quantum Security",
              isDisabled: false,
              showRawText: true,
              description:
                "Preparing for quantum computing threats and opportunities.",
              tags: ["Quantum", "Security", "Future"],
            },
          },
        ],
      },
      {
        path: "/capabilities/Cyber Space",
        state: "cn_cyber_space_container",
        sidebarProps: {
          displayText: "Cyber Space",
          isDisabled: false,
          showRawText: true,
          description:
            "Security solutions for space-based systems and infrastructure.",
        },
        children: [
          {
            path: "/console/soon",
            state: "cn_cyber_space",
            sidebarProps: {
              displayText: "Space",
              isDisabled: false,
              showRawText: true,
              description:
                "Security solutions for space-based systems and infrastructure.",
              tags: ["Space", "Security", "Satellite"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "https://app.powerbi.com/groups/me/reports/92f7e436-b643-45c2-b713-e0d5cd09b376/8b090ccc380834c83c47?experience=power-bi",
    state: "security_insights",
    sidebarProps: {
      displayText: "AMS_SECURITY_INSIGHTS",
      icon: "Insight",
      isDisabled: false,
    },
  }
]


export const sidebarData = [
  {
    path: "",
    state: "ams_admin_nav_root",
    sidebarProps: {
      adGroups: ["Platform Admin RW"],
      displayText: "AMS_ADMIN",
      icon: "admin",
      isDisabled: false,
    },
    children: [
      {
        path: "/capabilities/Dashboard",
        state: "admin_dashboard",
        sidebarProps: {
          adGroups: ["Platform Admin RW"],
          displayText: "Chat Proxy Dashboard",
          isDisabled: false,
          showRawText: true
        },
        children: [
          {
            path: "/console/secai/admin/home",
            state: "ams_home",
            sidebarProps: {
              adGroups: ["Platform Admin RW"],
              displayText: "Dashboard",
              isDisabled: false,
              showRawText: true,
              description: "A dashboard to manage/monitor all of the relevant backend collections",
              tags: ["Admin", "Monitoring", "Dashboard"],
            },
          },
        ]
      },
      {
        path: "/capabilities/Rag DAD",
        state: "admin_rag_dad",
        sidebarProps: {
          adGroups: ["Platform Admin RW"],
          displayText: "Rag DAD",
          isDisabled: false,
          showRawText: true
        },
        children: [
          {
            path: "/console/secai/ragdad",
            state: "ams_ragdad",
            sidebarProps: {
              adGroups: ["Platform Admin RW"],
              displayText: "RAG Management",
              isDisabled: false,
              showRawText: true,
              description: "Manage the documents and Indicies in this component",
              tags: ["Admin", "RAG", "Documents", "Indicies", "CRUD"],
            },
          },
        ]
      },
      {
        path: "/capabilities/Documentation",
        state: "ams_docs",
        sidebarProps: {
          adGroups: ["Platform Admin RW"],
          displayText: "Documentation",
          isDisabled: false,
          showRawText: true
        },
        children: [
          // {
          //   path: "/console/secai/docs/general",
          //   state: "ams_docs_general",
          //   sidebarProps: {
          //     adGroups: ["Platform Admin RW"],
          //     displayText: "General Documentation",
          //     isDisabled: false,
          //     showRawText: true,
          //     description: "A showcase of all the capabilities offered within this Unified UI",
          //     tags: ["Admin", "Documentation", "Showcase"],
          //   },
          // },
          {
            path: "/console/secai/docs/main",
            state: "ams_docs_main",
            sidebarProps: {
              adGroups: ["Platform Admin RW"],
              displayText: "API Documentation",
              isDisabled: false,
              showRawText: true,
              description: "Supplimentary documentation to the swagger",
              tags: ["Admin", "Documentation", "Swagger"],
            },
          },
          {
            path: "https://WINDOW_DOMAIN/api-docs",
            state: "ams_docs_swagger",
            sidebarProps: {
              adGroups: ["Platform Admin RW"],
              displayText: "Swagger Documentation",
              isDisabled: false,
              showRawText: true,
              description: "A Swagger UI for the Chat Proxy's APIs",
              tags: ["Admin", "API", "Swagger"],
            },
          },
        ]
      },
    ],
  },
  {
    path: "",
    state: "chat_root",
    sidebarProps: {
      displayText: "AMS_CHAT",
      icon: "MessageSquare",
      isDisabled: false,
    },
    children: [
      {
        path: "/capabilities/SecAI Models",
        state: "secai_models",
        sidebarProps: {
          displayText: "SecAI Models",
          isDisabled: false,
          showRawText: true,
          description: "AI-powered security chat and assistant models.",
        },
        children: [
          {
            path: "https://secai.chat/login",
            state: "gigantes",
            hasParameter: true,
            parameter: "gigantes",
            sidebarProps: {
              useNiceName: false,
              displayText: "SecAI Code",
              isDisabled: false,
              showRawText: true,
              description: "Efficient multi-model model",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          },
          {
            path: "/console/chat",
            state: "gigantes",
            hasParameter: true,
            parameter: "gigantes",
            sidebarProps: {
              useNiceName: false,
              displayText: "Nexus",
              isDisabled: false,
              showRawText: true,
              description: "Efficient multi-model model",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          },
          {
            path: "/console/chat",
            state: "gigantes_large",
            hasParameter: true,
            parameter: "gigantes-large",
            sidebarProps: {
              useNiceName: false,
              displayText: "Nexus Large",
              isDisabled: false,
              showRawText: true,
              description: "Large Reasoning Model for Complex Tasks",
              tags: ["AI", "Chat", "Security", "Files", "Large"],
            },
          },
          {
            path: "/console/chat",
            state: "chiron",
            hasParameter: true,
            parameter: "chiron",
            sidebarProps: {
              useNiceName: false,
              displayText: "Cortex",
              isDisabled: false,
              showRawText: true,
              description: "Large Model for Complex Tasks",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          },
          {
            path: "/console/chat",
            state: "gaia",
            hasParameter: true,
            parameter: "gaia",
            sidebarProps: {
              useNiceName: false,
              displayText: "Omnix",
              isDisabled: false,
              showRawText: true,
              description: "Large Model for Complex Tasks",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          }, {
            path: "/console/chat",
            state: "gaia-test",
            hasParameter: true,
            parameter: "gaia-test",
            sidebarProps: {
              useNiceName: false,
              displayText: "Omnix Preview",
              isDisabled: false,
              showRawText: true,
              description: "Large Reasoning Model for Complex Tasks",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          }, {
            path: "/console/chat",
            state: "gaia-small",
            hasParameter: true,
            parameter: "gaia-small",
            sidebarProps: {
              useNiceName: false,
              displayText: "Omnix Small",
              isDisabled: false,
              showRawText: true,
              description: "Efficient multi-model model",
              tags: ["AI", "Chat", "Security", "Files"],
            },
          },
        ],
      },
    ],
  },
];

// AS Reference: Provider API response Sample
// {
//   "name": "GPT4o",
//   "module": "GPT4o",
//   "options": {
//       "description": "GPT 4 Omni",
//       "nice_name": "GPT 4o",
//       "org": "OpenAI",
//       "access": [
//           "X"
//       ],
//       "models": [
//           "gpt-4o"
//       ],
//       "use": true,
//       "accepts_text": true,
//       "accepts_files": false
//   }
// },
